import React, { useContext } from 'react';
import {
	GameDevelopersContext,
	IGameDevelopersContext,
} from 'modules/Entertainment/Games/GameDevelopers/gameDevelopersState/gameDevelopersContext';
import SearchField from 'components/SearchField/SearchField';

const Search: React.FC = () => {
	const { changeSearchString, searchString } = useContext<IGameDevelopersContext>(GameDevelopersContext);

	return <SearchField onChangeSelectSearchString={changeSearchString} searchString={searchString} delay={800} />;
};

export default Search;
